import React from "react";
import { Route, Switch } from "react-router-dom";

import Dashboard from "./Dashboard/Index";
import Project from "./Project";
import Vendor from "./Vendor";
import Classification from "./Vendor/Classification";
import CreateVendor from "./Vendor/Create";
import DetailVendor from "./Vendor/Detail";
import UpdateVendor from "./Vendor/Update";
import DetailProject from "./Project/Detail";
import UpdateProject from "./Project/Update";
import CreateProject from "./Project/Create";
import SwitchProject from './Project/Switch';
import Register from './Register/Index';
import PassportDetail from './Passport/Detail';
import PassportUpdate from './Passport/Update/Index';
import PassportList from './Passport/List'
import RequestList from './Passport/Request';
import Faq from "./Support/Faq";
import About from "./Support/About";
import Home from './Support/Home';
import Users from './Users/Index';
import UserCreate from './Users/Create';
import UserDetail from './Users/Detail';
import UserUpdate from './Users/Update';
import Monitoring from './Tap/Index';
import SicknessList from './Sickness/Index';
import Skills from './Skills/Index';
import TrainingIndex from './Training/Index';
import TrainingCreate from './Training/Create';
import TrainingUpdate from './Training/Update';
import TrainingDetail from './Training/Detail';
import ManageFaq from './Faq/Manage';

import ViolationIndex from './Violation/Index';
import ViolationCreate from './Violation/Create';

import BroadcastManager from './Broadcast/Manage';
import Presence from './Presence/Index';

import { useSelector } from 'react-redux';
import Auxiliary from "../util/Auxiliary";
import NotFound from "./Errors/NotFound";
import ParamsProvider from "./Context/ParamsContext";

const App = ({ match }) => {
  const { authUser } = useSelector(({ auth }) => auth);

  return (
    <div className="gx-main-content-wrapper">
      <ParamsProvider>
        <Switch>
          {authUser.role === 'vendor' ? <VendorRoutes match={match} /> : null}
          {authUser.role === 'admin' ? <AdminRoutes match={match} /> : null}
          <Route component={NotFound} />
        </Switch>
      </ParamsProvider>
    </div>
  );
};

export default App;

const AdminRoutes = ({ match }) => (
  <Auxiliary>
    <Route path={`${match.url}dashboard`} component={Dashboard} />

    <Route path={`${match.url}vendor`} exact component={Vendor} />
    <Route path={`${match.url}vendor/create`} exact component={CreateVendor} />
    <Route path={`${match.url}vendor/update`} exact component={UpdateVendor} />
    <Route path={`${match.url}vendor/detail`} exact component={DetailVendor} />
    <Route path={`${match.url}vendor/classification`} exact component={Classification} />

    <Route path={`${match.url}project`} exact component={Project} />
    <Route path={`${match.url}project/create`} exact component={CreateProject} />
    <Route path={`${match.url}project/update`} exact component={UpdateProject} />
    <Route path={`${match.url}project/detail`} exact component={DetailProject} />
    <Route path={`${match.url}passport`} exact component={PassportList} />
    <Route path={`${match.url}passport/detail`} exact component={PassportDetail} />
    <Route path={`${match.url}passport/update`} exact component={PassportUpdate} />
    <Route path={`${match.url}request`} exact component={RequestList} />

    <Route path={`${match.url}users`} exact component={Users} />
    <Route path={`${match.url}users/create`} exact component={UserCreate} />
    <Route path={`${match.url}users/detail`} exact component={UserDetail} />
    <Route path={`${match.url}users/update`} exact component={UserUpdate} />

    <Route path={`${match.url}monitoring`} exact component={Monitoring} />

    <Route path={`${match.url}sickness`} exact component={SicknessList} />
    <Route path={`${match.url}skills`} exact component={Skills} />

    <Route path={`${match.url}training`} exact component={TrainingIndex} />
    <Route path={`${match.url}training/create`} exact component={TrainingCreate} />
    <Route path={`${match.url}training/update`} exact component={TrainingUpdate} />
    <Route path={`${match.url}training/detail`} exact component={TrainingDetail} />

    <Route path={`${match.url}violation`} exact component={ViolationIndex} />
    <Route path={`${match.url}violation/create`} exact component={ViolationCreate} />

    <Route path={`${match.url}faq/manage`} component={ManageFaq} />
    <Route path={`${match.url}broadcast`} component={BroadcastManager} />

    <Route path={`${match.url}presence`} component={Presence} />
  </Auxiliary>
);

const VendorRoutes = ({ match }) => (
  <Auxiliary>
    <Route path={`${match.url}dashboard`} component={Home} />
    <Route path={`${match.url}project/switch`} exact component={SwitchProject} />
    <Route path={`${match.url}passport`} exact component={PassportList} />
    <Route path={`${match.url}passport/register`} exact component={Register} />
    <Route path={`${match.url}passport/detail`} exact component={PassportDetail} />
    <Route path={`${match.url}faq`} component={Faq} />
    <Route path={`${match.url}about`} component={About} />
  </Auxiliary>
)
